import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('pkpTitle', pkpTitle);

    /**
     * Basically the missing ngTitle directive of Angular.
     *
     * @author flzemke.btc
     * @ngInject
     */
    function pkpTitle() {
        return {
            restrict: 'A',
            scope: {
                pkpTitle: '&'
            },
            link: linkFn
        };

        function linkFn(scope, elem) {
            scope.$watch(scope.pkpTitle, function (pkpTitle) {
                elem.attr('title', pkpTitle);
            });
        }
    }
})();
